// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cms-editor .editor-menu {
  position: fixed;
  z-index: 5;
  width: 100%;
  bottom: 0;
  padding: 10px;
  box-sizing: border-box;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.9));
}
.cms-editor .editor-menu .editor-container {
  display: flex;
  width: 80%;
}
.cms-editor .editor-menu .editor-tabs {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 100%;
  padding: 5px;
  box-sizing: border-box;
  border-right: 2px solid var(--motes-button-border);
}
.cms-editor .editor-menu .editor-tabs button {
  width: 30px;
  height: 30px;
  font-size: 22px;
  background-color: transparent;
  outline: none;
  color: rgb(129, 129, 129);
  border: none;
  pointer-events: initial;
}
.cms-editor .editor-menu .editor-tabs button.active-tab {
  color: white;
}
.cms-editor .editor-menu .editor-tabs button:hover {
  color: var(--motes-highlight-color);
}
.cms-editor .editor-menu upload-media {
  display: inline-block;
  width: 120px;
  height: 66px;
  pointer-events: initial;
  margin-right: 18px;
}
.cms-editor .editor-menu upload-media .allowed-types,
.cms-editor .editor-menu upload-media .drag-drop-text {
  display: none;
}
.cms-editor .editor-menu upload-media .drop-zone {
  min-height: 66px !important;
  height: 100%;
  overflow: hidden;
}
.cms-editor .editor-menu upload-media .action-panel {
  padding: 3px;
}
.cms-editor .editor-menu upload-media .drop-zone-inner {
  top: 0;
  transform: translateY(0);
  height: 100%;
}
.cms-editor .editor-menu upload-media .placeholder-image img, .cms-editor .editor-menu upload-media .upload-file img {
  margin-top: 0px;
  width: auto;
  height: 100%;
}
.cms-editor .editor-menu upload-media .upload-media, .cms-editor .editor-menu upload-media .media-drop-outer, .cms-editor .editor-menu upload-media .upload-file-layer, .cms-editor .editor-menu upload-media .upload-file, .cms-editor .editor-menu upload-media .media-preview, .cms-editor .editor-menu upload-media .drop-zone.file-not-empty {
  height: 100%;
}
.cms-editor .editor-menu .button-menu {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.cms-editor .editor-menu .button-menu .button-circled {
  opacity: 0;
  transform: translateX(50px);
  transition: 350ms;
}
.cms-editor .editor-menu .button-menu .button-circled.large {
  width: 55px;
  height: 55px;
  font-size: 26px;
}
.cms-editor .editor-menu .button-menu .button-circled.show-button {
  pointer-events: initial;
  opacity: 1;
  transform: translateX(0px);
}
.cms-editor .editor-menu .meta-editor {
  text-align: left;
  padding: 0px;
  padding-left: 12px;
  max-width: 70%;
  display: flex;
  flex-direction: column;
}
.cms-editor .editor-menu .meta-editor .meta-row {
  margin-top: 4px;
  position: relative;
  color: white;
}
.cms-editor .editor-menu .meta-editor .meta-input {
  border: 1px solid transparent;
  pointer-events: initial;
  margin-left: 0px;
  padding: 8px;
  z-index: 1;
}
.cms-editor .editor-menu .meta-editor .meta-input:focus {
  background-color: rgba(0, 0, 0, 0.8);
  border: 1px solid white;
  z-index: 2;
}
.cms-editor .editor-menu .meta-editor .meta-input.type, .cms-editor .editor-menu .meta-editor .meta-input.key {
  margin-right: 10px;
}
.cms-editor .editor-menu .meta-editor .meta-input.published {
  margin-left: 10px;
}
.cms-editor .editor-menu .meta-editor .meta-input.description, .cms-editor .editor-menu .meta-editor .meta-input.keywords {
  position: absolute;
  top: -9px;
  white-space: nowrap;
  max-width: 55vw;
  overflow: hidden;
  display: inline-flex;
  margin-left: 6px;
}
.cms-editor .editor-menu .meta-editor.image-upload {
  flex-direction: row;
}
.cms-editor .editor-menu .cropper-overlay {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100vw;
  pointer-events: none;
  background-color: rgba(0, 0, 0, 0.6);
  opacity: 0;
}
.cms-editor .cropper-overlay.shown {
  opacity: 1;
  transition: 150ms;
  pointer-events: initial;
}
.cms-editor upload-cropper {
  position: fixed;
  margin: auto;
  width: 60%;
  max-height: 70vh;
  display: block;
  top: 40%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
}
.cms-editor .upload-cropper {
  position: relative;
  width: 100%;
  padding: 12px;
  background-color: rgba(0, 0, 0, 0.322);
  pointer-events: initial;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/modules/cms-editor/cms-editor.component.scss"],"names":[],"mappings":"AAEI;EACI,eAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,6FAAA;AADR;AAGQ;EACI,aAAA;EACA,UAAA;AADZ;AAIQ;EACI,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,kDAAA;AAFZ;AAIY;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,6BAAA;EACA,aAAA;EACA,yBAAA;EACA,YAAA;EACA,uBAAA;AAFhB;AAKY;EAEI,YAAA;AAJhB;AAOY;EACI,mCAAA;AALhB;AASQ;EACI,qBAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;AAPZ;AASY;;EAEI,aAAA;AAPhB;AAUY;EACI,2BAAA;EACA,YAAA;EACA,gBAAA;AARhB;AAWY;EACI,YAAA;AAThB;AAYY;EACI,MAAA;EACA,wBAAA;EACA,YAAA;AAVhB;AAaY;EACI,eAAA;EACA,WAAA;EACA,YAAA;AAXhB;AAcY;EACI,YAAA;AAZhB;AAgBQ;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AAdZ;AAgBY;EACI,UAAA;EACA,2BAAA;EACA,iBAAA;AAdhB;AAgBgB;EACI,WAAA;EACA,YAAA;EACA,eAAA;AAdpB;AAiBgB;EACI,uBAAA;EACA,UAAA;EACA,0BAAA;AAfpB;AAoBQ;EACI,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;AAlBZ;AAqBY;EACI,eAAA;EACA,kBAAA;EACA,YAAA;AAnBhB;AAsBY;EACI,6BAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;AApBhB;AAuBY;EACI,oCAAA;EACA,uBAAA;EACA,UAAA;AArBhB;AAwBY;EACI,kBAAA;AAtBhB;AAyBY;EACI,iBAAA;AAvBhB;AA0BY;EACI,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;AAxBhB;AA4BQ;EACI,mBAAA;AA1BZ;AA6BQ;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,YAAA;EACA,oBAAA;EACA,oCAAA;EACA,UAAA;AA3BZ;AAgCI;EACI,UAAA;EACA,iBAAA;EACA,uBAAA;AA9BR;AAiCI;EACI,eAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,4CAAA;AA/BR;AAkCI;EACI,kBAAA;EACA,WAAA;EACA,aAAA;EACA,sCAAA;EACA,uBAAA;AAhCR","sourcesContent":[".cms-editor {\n\n    .editor-menu {\n        position: fixed;\n        z-index: 5;\n        width: 100%;\n        bottom: 0;\n        padding: 10px;\n        box-sizing: border-box;\n        background: linear-gradient(180deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.9));\n\n        .editor-container {\n            display: flex;\n            width: 80%;\n        }\n\n        .editor-tabs {\n            display: flex;\n            flex-direction: column;\n            justify-content: space-around;\n            height: 100%;\n            padding: 5px;\n            box-sizing: border-box;\n            border-right: 2px solid var(--motes-button-border);\n\n            button {\n                width: 30px;\n                height: 30px;\n                font-size: 22px;\n                background-color: transparent;\n                outline: none;\n                color: rgb(129, 129, 129);\n                border: none;\n                pointer-events: initial;\n            }\n\n            button.active-tab {\n                // color: var(--motes-highlight-color);\n                color: white;\n            }\n\n            button:hover {\n                color: var(--motes-highlight-color);\n            }\n        }\n\n        upload-media {\n            display: inline-block;\n            width: 120px;\n            height: 66px;\n            pointer-events: initial;\n            margin-right: 18px;\n\n            .allowed-types,\n            .drag-drop-text {\n                display: none;\n            }\n\n            .drop-zone {\n                min-height: 66px !important;\n                height: 100%;\n                overflow: hidden;\n            }\n\n            .action-panel {\n                padding: 3px;\n            }\n\n            .drop-zone-inner {\n                top: 0;\n                transform: translateY(0);\n                height: 100%;\n            }\n\n            .placeholder-image img, .upload-file img {\n                margin-top: 0px;\n                width: auto;\n                height: 100%;\n            }\n\n            .upload-media, .media-drop-outer, .upload-file-layer, .upload-file, .media-preview, .drop-zone.file-not-empty {\n                height: 100%\n            }\n        }\n\n        .button-menu {\n            display: flex;\n            align-items: center;\n            margin-bottom: 10px;\n\n            .button-circled {\n                opacity: 0;\n                transform: translateX(50px);\n                transition: 350ms;\n                \n                &.large {\n                    width: 55px;\n                    height: 55px;\n                    font-size: 26px;\n                }\n                \n                &.show-button {\n                    pointer-events: initial;\n                    opacity: 1;\n                    transform: translateX(0px);\n                }\n            }\n        }\n\n        .meta-editor {\n            text-align: left;\n            padding: 0px;\n            padding-left: 12px;\n            max-width: 70%;\n            display: flex;\n            flex-direction: column;\n            // border-left: 1px solid white;\n\n            .meta-row {\n                margin-top: 4px;\n                position: relative;\n                color: white;\n            }\n\n            .meta-input {\n                border: 1px solid transparent;\n                pointer-events: initial;\n                margin-left: 0px;\n                padding: 8px;\n                z-index: 1;\n            }\n\n            .meta-input:focus {\n                background-color: rgba(0, 0, 0, 0.8);\n                border: 1px solid white;\n                z-index: 2;\n            }\n\n            .meta-input.type, .meta-input.key {\n                margin-right: 10px;\n            }\n\n            .meta-input.published {\n                margin-left: 10px;\n            }\n\n            .meta-input.description, .meta-input.keywords {\n                position: absolute;\n                top: -9px;\n                white-space: nowrap;\n                max-width: 55vw;\n                overflow: hidden;\n                display: inline-flex;\n                margin-left: 6px;\n            }\n        }\n\n        .meta-editor.image-upload {\n            flex-direction: row;\n        }\n\n        .cropper-overlay {\n            position: fixed;\n            top: 0;\n            left: 0;\n            bottom: 0;\n            width: 100vw;\n            pointer-events: none;\n            background-color: #00000099;\n            opacity: 0;\n        }\n\n    }\n\n    .cropper-overlay.shown {\n        opacity: 1;\n        transition: 150ms;\n        pointer-events: initial;\n    }\n\n    upload-cropper {\n        position: fixed;\n        margin: auto;\n        width: 60%;\n        max-height: 70vh;\n        display: block;\n        top: 40%;\n        left: 50%;\n        transform: translateY(-50%) translateX(-50%);\n    }\n\n    .upload-cropper {\n        position: relative;\n        width: 100%;\n        padding: 12px;\n        background-color: rgba(0, 0, 0, 0.322);\n        pointer-events: initial;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
